import chroma from "chroma-js";
import styled from "styled-components";

export const Container = styled.div`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Status = styled.div<{
  color: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 6px;
  width: fit-content;
  min-height: 28px;
  background: ${({ color }) => chroma(color).alpha(0.1).hex()};
  border: 1px solid ${({ color }) => color};
  border-radius: 6px;

  p {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${({ color }) => chroma(color).darken(0.8).hex()};
    margin: 0 !important;
    padding: 0 !important;
  }
`;

export const BulletStatus = styled.div<{ color: string, offer?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  
  p {
    color: #222;
  }

  &::before {
    content: "";
    width: 0.9rem;
    height: 0.9rem;
    border-radius: ${({ offer }) => !offer ? "50%" : "0.2rem"};
    background-color: ${({ color }) => color};
  }
`;
